'use strict';

/* jshint -W098 */
angular.module('mean.foreman').controller('ClockCrewCtrl', ['$scope', '$rootScope', 'Users', 'Global', 'MeanUser', 'toaster', '$filter', 'clockHours',
  function($scope, $rootScope, Users, Global, MeanUser, toaster, $filter, clockHours) {
    var cc = this;
    cc.user = MeanUser.user;
    cc.clockType = '0';
    cc.returnedOptions = null;
    cc.timestamp = new moment();

    console.log('in the ClockCrewCtrl');

    cc.verify = function(emp) {
        if(!emp.password) {
            cc.loginError = 'Password not set';
            return;
        }

        if(emp.verified) {
            cc.loginError = 'User already has clocked time for this type';
            return;
        }

        if(cc.clockType === '0') {
            cc.loginError = 'Select a valid clock type';
            return;
        }

        if(cc.clockType !== 'clock_in') {
            //need to grab the hour object so we can pass it around
            var hour = $filter('filter')(cc.clockCrewOptions.hours, {'user': emp._id}, true)[0];

            if(!hour) {
                cc.loginError = 'No clock hour object.  Clock In first';
                return;
            }
        }

        if(cc.clockType === 'lunch_start' && !hour.clock_in) {
            cc.loginError = 'No clock hour object.  Clock In first';
            return;
        } else if(cc.clockType === 'lunch_end' && !hour.lunch_start) {
            cc.loginError = 'Clock lunch start first';
            return;
        } else if(cc.clockType === 'clock_out' && !hour.lunch_end) {
            cc.loginError = 'Clock lunch end first';
            return;
        } 

        cc.loginError = null;

        cc.returnedOptions = {
            username: emp.username,
            password: emp.password,
            type: 'DailyReportVerification',
            hour: hour
        };

        MeanUser.verifyuser(cc.returnedOptions);
    };

    // //clear out any passwords that might be sticking around if opened before
    // cc.clockCrewOptions.foreman.password = null;

    // for(var i=0; i<cc.clockCrewOptions.tradesmen.length; i++) {
    //     cc.clockCrewOptions.tradesmen[i].password = null;
    // }

    $rootScope.$on('crewUserVerifyFailed', function(event, data){
        var user = cc.getUser(data.username);

        user.failedVerify = true;
        user.verified = false;
        console.log(data);
    });

    $rootScope.$on('crewUserVerified', function(event, data){
        console.log('verified user identity');
        var user = cc.getUser(data.username);
        if(!user) return;

        if(cc.clockType === 'clock_in') {
            clockHours.clockIn(user, cc.timestamp).then(function(data) {
                $rootScope.$emit('crewHourUpdated', data);
            });
        } else {
            if(cc.clockType === 'lunch_start') {
                clockHours.lunchStart(user, data.hour, cc.timestamp).then(function(data) {
                    $rootScope.$emit('crewHourUpdated', data);
                });
            } else if(cc.clockType === 'lunch_end') {
                clockHours.lunchEnd(user, data.hour, cc.timestamp).then(function(data) {
                    $rootScope.$emit('crewHourUpdated', data);
                });
            } else if(cc.clockType === 'clock_out') {
                clockHours.clockOut(user, data.hour, cc.timestamp).then(function(data) {
                    $rootScope.$emit('crewHourUpdated', data);
                });
            }
        }

        user.verified = true;
        user.failedVerify = false;

        console.log(data);
    });

    cc.getUser = function(username) {
        var user = null;
        if(cc.clockCrewOptions.foreman.username === username) {
            user = cc.clockCrewOptions.foreman;
        }

        if(!user) {
            for(var i=0; i<cc.clockCrewOptions.tradesmen.length; i++) {
                if(cc.clockCrewOptions.tradesmen[i].username === username) {
                    user = cc.clockCrewOptions.tradesmen[i];
                    break;
                }
            }
        }

        return user;
    };

    cc.isHourValid = function(hour) {
        var valid = false;
        if(cc.clockType === 'clock_in' && hour.clock_in) {
            valid = true;
        } else if(cc.clockType === 'lunch_start' && hour.lunch_start) {
            valid = true;
        } else if(cc.clockType === 'lunch_end' && hour.lunch_end) {
            valid = true;
        } else if(cc.clockType === 'clock_out' && hour.clock_out) {
            valid = true;
        }
        return valid;
    };

    cc.changeClockType = function() {
        var hour = $filter('filter')(cc.clockCrewOptions.hours, {
            'user':cc.clockCrewOptions.foreman._id}, true)[0];

        if(hour) {
            cc.clockCrewOptions.foreman.verified = cc.isHourValid(hour);
        }

        _.each(cc.clockCrewOptions.tradesmen, function(user) {
            hour = $filter('filter')(cc.clockCrewOptions.hours, {
                'user': user._id }, true)[0];

            if(hour) {
                user.verified = cc.isHourValid(hour);
            }
        });
    };

  }
]);



// WEBPACK FOOTER //
// ./packages/custom/foreman/public/controllers/clockCrew.js